import React from 'react';
import { useTranslation } from 'react-i18next';
import { Routes, Route, Navigate } from 'react-router-dom';
import AchatsAlertsPage from './AchatsAlertsPage';
import CatalogueFournisseurPage from './CatalogueFournisseurPage';
import DemandesAchatPage from './DemandesAchatPage';
import CommandesFournisseursPage from './CommandesFournisseursPage';
import LivreDesAchatsPage from './LivreDesAchatsPage';
import ReceptionsAchatsPage from './ReceptionsAchatsPage';
import RetoursAchatsPage from './RetoursAchatsPage';
import StrategieAchatPage from './StrategieAchatPage';
import PlanificationAchatsPage from './PlanificationAchatsPage';
import AppelsOffresPage from './AppelsOffresPage';
import NegociationsPage from './NegociationsPage';
import ControleQualitePage from './ControleQualitePage';
import BudgetAchatsPage from './BudgetAchatsPage';
import RisquesTracabilitePage from './RisquesTracabilitePage';
import PrevisionsPage from './PrevisionsPage';
import OptimisationPage from './OptimisationPage';
import DelaisLeadTimePage from './DelaisLeadTimePage';
import AchatsConfigPage from './AchatsConfigPage';
import AnalysesRapportsAchatsPage from './AnalysesRapportsAchatsPage';
import ComparatifOffresPage from './ComparatifOffresPage';
import PurchasingDashboardPage from './PurchasingDashboardPage';

const AchatsMainPage = () => {
  const { t } = useTranslation();
  const p = (key, opts) => t(`modules.achats.pages.achatsMainPage.${key}`, opts);

  return (
    <div aria-label={p('title')}>
    <span className="sr-only">{p('subtitle')}</span>
    <Routes>
      <Route path="/" element={<Navigate to="/achats/dashboard" replace />} />
      <Route path="/dashboard" element={<PurchasingDashboardPage />} />
      <Route path="/alertes" element={<AchatsAlertsPage />} />
      
      {/* Sections Opérationnelles */}
      <Route path="/catalogue" element={<CatalogueFournisseurPage />} />
      <Route path="/demandes" element={<DemandesAchatPage />} />
      <Route path="/commandes" element={<CommandesFournisseursPage />} />
      <Route path="/livre-des-achats" element={<LivreDesAchatsPage />} />
      <Route path="/receptions" element={<ReceptionsAchatsPage />} />
      <Route path="/retours" element={<RetoursAchatsPage />} />
      
      {/* Sections Stratégiques */}
      <Route path="/previsions" element={<PrevisionsPage />} />
      <Route path="/optimisation" element={<OptimisationPage />} />
      <Route path="/strategie" element={<StrategieAchatPage />} />
      <Route path="/planification" element={<PlanificationAchatsPage />} />
      <Route path="/lead-times" element={<DelaisLeadTimePage />} />
      <Route path="/appels-offres" element={<AppelsOffresPage />} />
      <Route path="/comparatif-offres" element={<ComparatifOffresPage />} />
      <Route path="/negociations" element={<NegociationsPage />} />
      <Route path="/qualite" element={<ControleQualitePage />} />
      <Route path="/risques-tracabilite" element={<RisquesTracabilitePage />} />
      <Route path="/budget" element={<BudgetAchatsPage />} />
      
      {/* Configuration */}
      <Route path="/config" element={<AchatsConfigPage />} />

      <Route path="/analyses-rapports" element={<AnalysesRapportsAchatsPage />} />

      <Route path="/*" element={<Navigate to="/achats/dashboard" replace />} />
    </Routes>
    </div>
  );
};

export default AchatsMainPage;

